import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.06 7.73l-.7-.7a1.22 1.22 0 0 1-.35-.85V5.2A3.2 3.2 0 0 0 14.8 2h-1a1.2 1.2 0 0 1-.85-.35l-.7-.7a3.2 3.2 0 0 0-4.53 0l-.7.7a1.2 1.2 0 0 1-.85.35H5.2A3.2 3.2 0 0 0 2 5.19v1c0 .3-.13.62-.35.84l-.7.7a3.2 3.2 0 0 0 0 4.53l.7.7c.22.23.35.54.35.85v1a3.2 3.2 0 0 0 3.2 3.2h1c.31 0 .62.12.84.35l.7.7A3.2 3.2 0 0 0 10 20a3.2 3.2 0 0 0 2.26-.94l.7-.7c.23-.23.53-.35.85-.35h1a3.2 3.2 0 0 0 3.2-3.2v-1c0-.31.13-.62.35-.85l.7-.7a3.2 3.2 0 0 0 0-4.53M12.3 6.3l-6 6a1 1 0 1 0 1.4 1.4l6-6a1 1 0 1 0-1.4-1.4M7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m5.16-.14l-.7.7A3.18 3.18 0 0 0 16 13.8v1c0 .66-.54 1.2-1.2 1.2h-1a3.18 3.18 0 0 0-2.26.94l-.7.7a1.2 1.2 0 0 1-1.7 0l-.7-.7A3.18 3.18 0 0 0 6.18 16H5.2A1.2 1.2 0 0 1 4 14.8v-1c0-.85-.33-1.66-.94-2.26l-.7-.7a1.2 1.2 0 0 1 0-1.7l.7-.7c.6-.6.94-1.41.94-2.27V5.2C4 4.54 4.54 4 5.2 4h1c.85 0 1.65-.33 2.26-.94l.7-.7a1.2 1.2 0 0 1 1.7 0l.7.7a3.18 3.18 0 0 0 2.26.94h1c.66 0 1.2.54 1.2 1.2v1c0 .85.33 1.65.93 2.26l.7.7a1.2 1.2 0 0 1 0 1.7"
});

var SvgDiscountsMajorMonotone = function SvgDiscountsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgDiscountsMajorMonotone as S };
